import { TwoFactorVerificationFailureKey } from '../types/TwoFactorVerificationFailure';

export const TWO_FACTOR_VERIFICATION_FAILURE_MESSAGES: Record<
  TwoFactorVerificationFailureKey,
  string
> = {
  'two_factor.code_expired':
    'Your verification code has expired. Please request a new code.',
  'two_factor.code_incorrect':
    'That code is incorrect. Please check it and try again.',
  'two_factor.attempts_exhausted':
    'Too many incorrect attempts. Please request a new code.',
  'two_factor.request_throttled':
    'Too many attempts. Please wait a minute and then try again.',
} as const;
